const contduct = () => import('./contduct');
const behavior = () => import('./behavior');

const logRouter = [
  {
    path: '/log/contduct/:id/:key?', name: 'contduct', component: contduct, meta: { c: 'log', a: 'contduct' }
  },
  {
    path: '/log/behavior/:id/:key?', name: 'behavior', component: behavior, meta: { c: 'log', a: 'behavior' }
  },
];

export default logRouter;
